import { useQuery } from '@tanstack/react-query';
import {
  getEventSummary,
  listEventsForReport,
  getEventTransactions,
  type EventSummary,
  type EventListItem,
} from '@/lib/api/reports';

const KEYS = {
  all: ['reports'] as const,
  events: () => [...KEYS.all, 'events'] as const,
  summary: (eventId: string) => [...KEYS.all, 'summary', eventId] as const,
  transactions: (eventId: string) => [...KEYS.all, 'transactions', eventId] as const,
};

export const useEventsForReport = () =>
  useQuery({
    queryKey: KEYS.events(),
    queryFn: () => listEventsForReport(),
    staleTime: 30 * 1000,
  });

export const useEventSummary = (eventId: string | null) =>
  useQuery({
    queryKey: KEYS.summary(eventId ?? ''),
    queryFn: () => (eventId ? getEventSummary(eventId) : Promise.resolve(null)),
    enabled: !!eventId,
    staleTime: 30 * 1000,
  });

export const useEventTransactions = (eventId: string | null) =>
  useQuery({
    queryKey: KEYS.transactions(eventId ?? ''),
    queryFn: () => (eventId ? getEventTransactions(eventId) : Promise.resolve([])),
    enabled: !!eventId,
    staleTime: 30 * 1000,
  });

export type { EventSummary, EventListItem };
